import React from "react";
import styled from "styled-components";

import { DataLoadingLayout } from "common/utils/DataLoadingLayout";
import {
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_EXPANDED,
  sideBarProfileSize,
  sideBarAnimationDuration,
} from "common/const/const";

////////////////////////////////////////////////////////////////////

const SmallIconWrapper = styled.span`
  width: 1.25rem;
  height: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

const TextBase = styled.p`
  margin: 0;
  padding: 0;
  color: ${({ color }) => color ?? "inherit"};
`;

const TextTitle4 = styled(TextBase)`
  font-size: var(--fontSize-16);
  font-weight: var(--fontWeight-700);
  line-height: 100%;
  letter-spacing: 0rem;
  white-space: normal; /* 기본값: 줄바꿈 허용 */
  word-wrap: break-word; /* 긴 단어도 영역에 맞춰 개행 */
  overflow-wrap: break-word; /* 최신 표준, word-wrap과 동일 */
`;

const TextMenu = styled(TextBase)`
  font-size: var(--fontSize-14);
  font-weight: var(--fontWeight-400);
  line-height: 100%;
  letter-spacing: 0rem;
`;

////////////////////////////////////////////////////////////////////

const SideBarProfileLayout = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;

  box-sizing: border-box;
  width: ${({ $isOpen }) => ($isOpen ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH)};
  min-height: 8rem;
  padding: 1rem ${({ $isOpen }) => ($isOpen ? "1.5rem" : "1rem")};
  border-bottom: 0.5px solid var(--Gray);

  transition: ${sideBarAnimationDuration} ease-in-out;
`;

const SideBarProfileButton = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  transition: ${sideBarAnimationDuration} ease-in-out;
`;

const ProfileImageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${({ $isOpen }) => ($isOpen ? "4rem" : sideBarProfileSize)};
  height: ${({ $isOpen }) => ($isOpen ? "4rem" : sideBarProfileSize)};
  border-radius: 0.5rem;
  overflow: hidden;
  transition: all ${sideBarAnimationDuration} ease-in-out;
`;

const SideBarProfileField = ({ isOpen, clubImageRef, roleName, clubName }) => {
  return (
    <SideBarProfileLayout $isOpen={isOpen}>
      <SideBarProfileButton $isOpen={isOpen}>
        <DataLoadingLayout loading={!clubImageRef}>
          <ProfileImageWrapper $isOpen={isOpen}>
            <img
              src={clubImageRef}
              alt="profile"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </ProfileImageWrapper>
        </DataLoadingLayout>
      </SideBarProfileButton>
      {isOpen && (
        <>
          <SideBarProfileInfo>
            <DataLoadingLayout loading={!roleName || !clubName}>
              <TextTitle4>{clubName}</TextTitle4>
              <TextMenu color="var(--LightNavy)">{roleName}</TextMenu>
            </DataLoadingLayout>
          </SideBarProfileInfo>
        </>
      )}
    </SideBarProfileLayout>
  );
};

const SideBarProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; // 이거 왜 안되지

  color: var(--DarkNavy);
`;

export default SideBarProfileField;
